import { useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import AuthenticateStyles from './AuthenticateStyles';
import Amplify, { Auth } from 'aws-amplify';
import awsconfig from '../../aws-exports';
import { navigate } from "@reach/router";
import { StoreContext } from '../../context';
import { useContextSelector } from '@fluentui/react-context-selector';
import { Spinner } from 'ams-ui-reactkit';
import { setItemToSessionStorage, clearSessionStorage } from '../../utils/storageUtils';
import actionTypeConstants from '../../utils/actionTypeConstants'

export type AuthenticateViewProps = {
  templateProps: {
    statusBarOptions?: any,
    callButtons?: any
    sidebarItemList?: any,
    nextScreen?: string
  },
  url?: any
  history: History
};

Amplify.configure(awsconfig);

const Authenticate = (props: AuthenticateViewProps) => {
  const classes = AuthenticateStyles();
  const dispatch: any = useContextSelector(StoreContext, store => store?.dispatch);

  useEffect(() => {
    getLogged()
  }, [])


  const handleDriverLogin = async (phoneNumber: any, password: any) => {

    let endPoint = `${process.env.REACT_APP_KPI_DASHBOARD_PATH}/getDriverLogin`

    return fetch(endPoint, {
      method: 'post',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'x-api-key': `${process.env.REACT_APP_KPI_DASHBOARD_KEY}`
      },
      body: JSON.stringify({
        "phoneNo": phoneNumber ? phoneNumber.replace(/\D/g, '') : "",
        "dob": password ? password : "",
      })
    })
      .then(response => response.json())
      .catch(e => {
        console.log("Error in handleDriverLogin", e);
        return null;
      });

  }

  const getLogged = async () => {
    const queryParams = new URLSearchParams(window.location.search);
    let phone = queryParams.get("phone");
    let dob = queryParams.get("dob");
    let customerId = queryParams.get("customerId");
    let bolType = queryParams.get("bolType");
    let dailysheetId = queryParams.get("dailysheetId");

    clearSessionStorage();
    await Auth.signOut();

    if (bolType) {
      setItemToSessionStorage('bolType', bolType);
      dispatch({
        'type': actionTypeConstants.BOL_DATA,
        'payload': { bolType }
      })
    }
    if (customerId) {
      setItemToSessionStorage('customerId', customerId);
      dispatch({
        'type': actionTypeConstants.BOL_DATA,
        'payload': { customerId }
      })
    }
    if (dailysheetId) {
      setItemToSessionStorage('dailysheetId', dailysheetId);
      dispatch({
        'type': actionTypeConstants.BOL_DATA,
        'payload': { dailysheetId }
      })
    }

    if (phone?.trim() && dob?.trim()) {

      const resp = await handleDriverLogin(phone, dob);

      if (resp) {

        const { username, password } = resp;

        await Auth.signIn(username, password).then((res: any) => {
          dispatch({
            'type': actionTypeConstants.UPDATE_USER,
            'payload': { ...res.attributes, "username": res.attributes.name }
          })
          if (bolType === "1") {
            navigate("/ack")
          } else {
            navigate("/bol")
          }
        }).catch((e) => {
          navigate("/login")
        })
      } else {
        console.log("Didn't get the response from handleDriverLogin");
        navigate("/login")
      }

    } else {
      navigate("/login")
    }
  }

  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      className={classes.mainContainer}
    >
      <div className='flex-center h-100vh'>
        <Spinner />
      </div>
    </Grid>
  );

}

export default Authenticate